export enum ExploreBudgetsTrackedComponent {
  BUDGET_MIX_CARD = "Budget mix card",
  BUDGET_MIX_CARD_KPI_SELECTOR = "Budget mix card KPI selector",
  BUDGET_MIX_CARD_CAC_METRIC_SELECTOR = "Budget mix card CAC metric selector",
  BUDGET_MIX_CARD_ROAS_METRIC_SELECTOR = "Budget mix card ROAS metric selector",
  FILTER_BUDGET_MIX_DROPDOWN = "Filter budget mix dropdown",
  FILTER_BUDGET_MIX_BY_STRATEGY_NAME_DROPDOWN = "Filter budget mix by strategy name dropdown",
  BUDGET_MIX_TABLE_CHART_TOGGLE = "Budget mix table/chart toggle",
  CHANGE_ADOPTED_MIX_CONFIRMATION_MODAL = "Change adopted mix confirmation modal",
  ADOPT_A_MIX_BUTTON = "Budget mix card adopt a mix button",
  EXPANDED_BUDGET_MIX_CHART_MODAL = "Expanded budget mix chart modal",
  DELETE_BUDGET_MIX_CARD_BUTTON = "Delete budget mix card button",
  HIDE_BUDGET_MIX_CARD_BUTTON = "Hide budget mix card button",
  HISTORICAL_BUDGET_MIX_DATE_PERIOD_SELECTOR = "Historical budget mix date period selector",
  HISTORICAL_BUDGET_MIX_CUSTOM_DATE_CALENDAR = "Historical budget mix custom date calendar",
  EXPORT_RECOMMENDED_BUDGET_MIX_SELECTOR = "Export recommended budget mix selector",
  EXPORT_HISTORICAL_BUDGET_MIX_SELECTOR = "Export historical budget mix selector",
  HISTORICAL_BUDGET_MIX_CARD = "Historical budget mix card",
  DELETE_CLIENT_SETTING_BUTTON = "Delete client setting button",
  DUPLICATE_CLIENT_SETTING_BUTTON = "Duplicate client setting button",
  COPY_HISTORICAL_CLIENT_SETTING_SELECTOR = "Copy historical client setting selector",
  CLIENT_SETTING_FORM = "Client setting form",
  CUSTOM_MIX_BUDGET_MIX_CARD = "Create custom mix budget card",
  SHOW_ALL_BUDGET_MIX_CARD = "Show all budget mix card",
  GENERATE_BUDGETS_FOR_CLIENT_SETTING_BUTTON = "Generate budgets for client setting button",
  GENERATE_BUDGETS_FOR_ALL_CLIENT_SETTINGS_BUTTON = "Generate budgets for all client settings button",
  GENERATE_BUDGETS_CONFIRMATION_MODAL = "Generate budgets confirmation modal",
}

export enum ModelInsightsTrackedComponent {
  INCREMENTAL_SPEND_CHART = "Incremental spend chart",
  INCREMENTAL_ROAS_CHART = "Incremental ROAS chart",
  MODEL_FIT_CHART = "Model fit chart",
  CHANNEL_INSIGHTS_SORT_BY_SELECTOR = "Channel insights sort by selector",
  TOP_BAR_KPI_SELECTOR = "Top bar KPI selector",
  TOP_BAR_MODEL_TRAINING_DETAILS_BUTTON = "Top bar model training details button",
  KPI_SELECTOR = "KPI selector",
  MODEL_TRAINING_DETAILS_BUTTON = "Model training details button",
  MODEL_TRAINING_DETAILS_MODAL = "Model training details modal",
  EXPORT_MODEL_FIT_BUTTON = "Export model fit button",
  EXPORT_CHANNEL_INSIGHTS_MODAL = "Export channel insights modal",
  EXPORT_CHANNEL_INSIGHTS_PERIOD_SELECTOR = "Export channel insights modal period selector",
  EXPORT_CHANNEL_INSIGHTS_CHANNEL_SELECTOR = "Export channel insights modal channel selector",
  ALL_CHANNEL_GENERAL_INSIGHTS_GRAPH = "All channel general insights graph",
  ALL_CHANNEL_GENERAL_INSIGHTS_GRAPH_TIME_PERIOD_SELECTOR = "All channel general insights graph time period selector",
  ALL_CHANNEL_GENERAL_INSIGHTS_GRAPH_METRIC_SELECTOR = "All channel general insights graph metric selector",
  COLLAPSE_ALL_CHANNEL_INSIGHT_ROWS_BUTTON = "Collapse all channel insight rows button",
  CHANNEL_INSIGHTS_ROW = "Channel insights row",
  MODEL_FIT_TIME_PERIOD_SELECTOR = "Model fit time period selector",
  INCREMENTAL_ROAS_PERIOD_SELECTOR = "Incremental ROAS period selector",
  INCREMENTAL_SPEND_PERIOD_SELECTOR = "Incremental spend period selector",
}

export enum CreateCustomBudgetTrackedComponent {
  ADD_TO_EXPLORE_MIXES_MODAL = "Add to explore mixes modal",
  UPLOAD_DATA_MODAL = "Upload data modal",
  FORECAST_CHART = "Forecast chart",
  CUSTOM_UPLOAD_DATA_ROW = "Custom upload data row",
}

export enum TrackPerformanceTrackedComponent {
  ABOUT_THIS_SETTING_MODAL = "About this setting modal",
  PERFORMANCE_TRACKING_TABLE = "Performance tracking table",
  METRIC_SELECTOR = "Metric selector",
  KPI_CHART_AGGREGATE_SELECTOR = "KPI chart aggregate selector",
  KPI_CHART_SPLIT_SELECTOR = "KPI chart split selector",
  KPI_CHART = "KPI chart",
  SPEND_CHART_AGGREGATE_SELECTOR = "Spend chart aggregate selector",
  SPEND_CHART_SPLIT_SELECTOR = "Spend chart split selector",
  SPEND_CHART = "Spend chart",
  ALTER_BUDGET_REBUDGETING_TABLE = "Alter budget rebudgeting table",
  FORECAST_MID_CYCLE_BUDGET_REALLOCATION = "Forecast mid cycle budget reallocation",
  ADOPT_MID_CYCLE_BUDGET_REALLOCATION_FORECAST = "Adopt mid cycle budget reallocation forecast",
}
export enum RecapPerformanceTrackedComponent {
  VIEW_SETTING_IN_EXPLORE_BUDGETS_LINK = "View setting in explore budgets link",
  ABOUT_THIS_SETTING_MODAL = "About this setting modal",
  VIEW_SPEND_IN_PERFORMANCE_TRACKING_LINK = "View spend in performance tracking link",
  KPI_SELECTOR = "KPI selector",
  WEEKLY_ACCURACY_CHART = "Weekly accuracy chart",
}

export enum CreateMediaPlanTrackedComponent {
  CREATE_MEDIA_PLAN_MODAL = "Create media plan modal",
  DELETE_MEDIA_PLAN_BUTTON = "Delete media plan button",
  DELETE_MEDIA_PLAN_CONFIRMATION_BUTTON = "Delete media plan confirmation button",
  CREATE_MEDIA_PLAN_MODAL_NEXT_BUTTON = "Save media plan draft",
}

export enum CommonTrackedComponent {
  NOTIFICATION = "Notification",
  CYCLE_SELECTOR = "Cycle selector",
  TAB_SELECTOR = "Tab selector",
  WHOLE_PAGE = "Page",
  ANNOTATIONS = "Annotations",
}
export type TrackedComponent =
  | ExploreBudgetsTrackedComponent
  | ModelInsightsTrackedComponent
  | CreateCustomBudgetTrackedComponent
  | TrackPerformanceTrackedComponent
  | RecapPerformanceTrackedComponent
  | CreateMediaPlanTrackedComponent
  | CommonTrackedComponent;
